import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BadgeCelebrationStateModel, BadgeItemModel } from '../achievements.model';

const CELEBRATION_PREVIEW_COUNT = 4;
const CONFETTI_COUNT = 28;
const CONFETTI_COLORS = ['#8950fc', '#1bc5bd', '#ffa800', '#f64e60', '#3699ff'];

interface ConfettiPiece {
  left: number;
  delay: number;
  duration: number;
  color: string;
}

/**
 * Animated "new achievement" moment for badges earned since the last celebration. Any way of
 * closing it counts as seen; "See all achievements" additionally opens the achievements page.
 */
@Component({
  selector: 'app-achievements-celebration-dialog',
  templateUrl: './achievements-celebration-dialog.component.html',
  styleUrls: ['./achievements-celebration-dialog.component.scss'],
  animations: [
    trigger('badgePop', [
      transition(':enter', [
        style({ transform: 'scale(0.3) rotate(-20deg)', opacity: 0 }),
        animate(
          '600ms {{ delay }}ms ease-out',
          keyframes([
            style({ transform: 'scale(0.3) rotate(-20deg)', opacity: 0, offset: 0 }),
            style({ transform: 'scale(1.15) rotate(6deg)', opacity: 1, offset: 0.7 }),
            style({ transform: 'scale(1) rotate(0)', opacity: 1, offset: 1 }),
          ])
        ),
      ], { params: { delay: 0 } }),
    ]),
  ],
})
export class AchievementsCelebrationDialogComponent {
  readonly state: BadgeCelebrationStateModel;
  readonly preview: BadgeItemModel[];
  readonly confetti: ConfettiPiece[];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BadgeCelebrationStateModel,
    private dialogRef: MatDialogRef<AchievementsCelebrationDialogComponent>,
    private router: Router
  ) {
    this.state = data;
    this.preview = (data?.badges || []).slice(0, CELEBRATION_PREVIEW_COUNT);
    this.confetti = Array.from({ length: CONFETTI_COUNT }, (_, i) => ({
      left: Math.random() * 100,
      delay: Math.random() * 600,
      duration: 1800 + Math.random() * 1200,
      color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    }));
  }

  get single(): BadgeItemModel {
    return this.state?.badges?.length === 1 ? this.state.badges[0] : null;
  }

  get hiddenCount(): number {
    return Math.max(0, (this.state?.badges?.length || 0) - this.preview.length);
  }

  seeAll(): void {
    this.dialogRef.close(true);
    this.router.navigate(['/profile/achievements']);
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
